<template>
  <div class="container section">
    <back-navigation
      :redirect="{
        name: 'resources.view',
        params: { slug: $route.params.slug }
      }"
    />
    <skeleton-loading v-if="isLoading" />
    <template v-else-if="video">
      <video-player
        class="vjs-theme-fantasy"
        @waiting="onWaiting"
        :options="playerOptions"
      />

      <div class="columns tw-mt-8">
        <div class="column is-three-fifths">
          <h1
            class="tw-font-bold tw-leading-none is-size-1 has-text-black is-uppercase"
          >
            {{ video.title }}
          </h1>

          <p class="tw-mt-10">
            {{ video.description }}
          </p>
        </div>
        <div class="column"></div>
        <div class="column is-narrow">
          <b-button
            :class="{ 'tw-ml-10': !video.owned_bookmark }"
            v-if="!session && currentGroup && currentGroup.is_owner"
            @click="createSession"
            type="is-primary"
          >
            Create a Group Session
          </b-button>
        </div>
      </div>

      <div class="columns">
        <div class="column is-one-third">
          <div class="section-block">
            <span class="title tw-uppercase">TIPS FOR DISCUSSION!</span>
          </div>

          <div class="content quill" v-html="video.notes"></div>
        </div>
        <div class="column">
          <div class="section-block">
            <span class="title tw-uppercase">Discussion Notes</span>
          </div>

          <div class="content quill" v-html="video.tips"></div>

          <template v-if="video.attachments.length">
            <div class="section-block">
              <span class="title">ATTACHMENTS</span>
            </div>

            <div>
              <div
                class="tw-my-4"
                v-for="attachment in video.attachments"
                :key="attachment.id"
              >
                <a
                  class="tw-py-1 tw-px-6 tw-bg-grey-lightest tw-rounded-full tw-text-gray-300"
                  :href="attachment.url"
                  target="_blank"
                >
                  <span>{{ attachment.file_name }}</span>
                  <!-- <b-icon icon="download"></b-icon> -->
                </a>
              </div>
            </div>
          </template>

          <div class="section-block">
            <span class="title">FEEDBACK & IDEAS</span>
          </div>
          <comment v-if="video" type="resource_videos" :id="video.id" />
        </div>
      </div>

      <!-- create session -->
      <create-session-modal
        @created="getResourceSession"
        :video="video"
        ref="createSession"
      />
    </template>
  </div>
</template>

<script>
import Resource from '@/models/Resource'
import CreateSessionModal from '@/components/modals/CreateSession'
import env from '@/services/env'
import { mapState } from 'vuex'
import { videoPlayer } from 'vue-video-player'
import * as ResourceType from '@/utils/consts/ResourceType'
import BackNavigation from '@/components/BackNavigation'
import Comment from '@/components/comment'

export default {
  components: {
    CreateSessionModal,
    videoPlayer,
    BackNavigation,
    Comment
  },
  metaInfo() {
    if (this.video) {
      return {
        title: this.video.title
      }
    }
  },
  data() {
    return {
      env,
      video: null,
      session: null,
      isSubmitting: false,
      isLoading: false
    }
  },
  async mounted() {
    const { slug, course } = this.$route.params
    this.getResourceVideo(slug, course).then(this.getResourceSession)
  },
  computed: {
    ...mapState({
      currentGroup: state => state.currentGroup
    }),
    playerOptions() {
      if (this.video) {
        return {
          aspectRatio: '16:9',
          muted: true,
          poster: this.video.cover.url,
          techOrder: ['youtube', 'vimeo'],
          sources: [
            {
              type: this.video.isVimeo ? 'video/vimeo' : 'video/youtube',
              src: this.video.video_url
            }
          ],
          controls: true
        }
      }
      return null
    }
  },
  methods: {
    getResourceVideo(slug, course) {
      this.isLoading = true
      const resource = new Resource({ id: slug })
      return resource
        .videos()
        .include('attachments', 'cover', 'resource.cover', 'owned_bookmark')
        .where('type', ResourceType.LTG)
        .$find(course)
        .then(video => {
          this.video = video
          this.video.resource = new Resource(video.resource)
        })
        .catch(() => {
          this.$router.replace({ name: 'resources' })
        })
        .then(() => {
          this.isLoading = false
        })
    },

    getResourceSession() {
      return this.currentGroup
        .sessions()
        .$find(this.video.id)
        .then(session => {
          this.session = session
        })
        .catch(() => {})
    },

    onWaiting(e) {
      const playButton = document.getElementsByClassName('vjs-big-play-button')
      playButton[0].style.display = 'none'
    },

    createSession() {
      this.$refs.createSession.open()
    },

    bookmark() {
      this.isSubmitting = true
      this.$api
        .post(`/resource-videos/${this.video.id}/bookmark`)
        .then(({ data }) => {
          this.video.owned_bookmark = data.data
          this.$buefy.snackbar.open({
            type: 'is-success',
            message: 'Lesson has been successfully bookmarked.',
            position: 'is-top'
          })
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-danger',
            message: 'Cannot bookmark lesson',
            position: 'is-top'
          })
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
